export const getCurrencyString = (amount) => {
  const val = Math.abs(amount);
  let negative = "";
  if (amount < 0) {
    negative = "-";
  }
  return `${negative}${val.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    currency: "USD",
    style: "currency",
  })}`;
};

export const formatOpenBalanceDisplay = (openBalance) => {
  if (openBalance == null) return "";

  const value = parseFloat(openBalance);

  const formattedCurrency = Math.abs(value).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    currency: "USD",
    style: "currency",
  });

  if (value < 0) {
    const formattedWithoutSymbol = formattedCurrency.replace(/^\$/, "");
    return `($${formattedWithoutSymbol})`;
  }

  return formattedCurrency;
};
